import React, { useState } from "react";

interface FAQItem {
  q: string;
  a: string;
}

interface FAQProps {
  faq: FAQItem[];
}

const FAQ: React.FC<FAQProps> = ({ faq }) => {
  const [open, setOpen] = useState<number | null>(null);
  return (
    <section data-section="faq" className="py-8 md:py-12">
      <div className="max-w-3xl mx-auto px-4">
        <h2 className="text-2xl font-bold text-white mb-6 text-center">FAQ</h2>
        <div className="divide-y divide-white/10 rounded-xl bg-white/5">
          {faq.map((item, i) => (
            <div key={i}>
              <button
                className="w-full text-left px-4 py-3 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-400 flex justify-between items-center"
                aria-expanded={open === i}
                aria-controls={`faq-panel-${i}`}
                onClick={() => setOpen(open === i ? null : i)}
              >
                <span className="font-semibold text-white">{item.q}</span>
                <span className="ml-2 text-white/70">{open === i ? "−" : "+"}</span>
              </button>
              <div
                id={`faq-panel-${i}`}
                className={`px-4 pb-3 text-white/80 text-sm transition-all duration-200 ${open === i ? "block" : "hidden"}`}
                role="region"
                aria-labelledby={`faq-header-${i}`}
              >
                {item.a}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
